var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriaSideIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "IA_PRIA-03 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.9233 6.68359C43.9233 6.68359 47.9052 9.37043 49.672 15.591C51.4377 21.8116 42.1301 14.3461 42.1301 14.3461L43.9233 6.68465V6.68359Z",
    fill: "url(#paint0_linear_988_2954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.7259 14.2617C46.7259 14.2617 45.6405 5.96507 42.8716 4.85773C40.1027 3.75038 36.509 7.82616 36.509 7.82616L46.7259 14.2617Z",
    fill: "url(#paint1_linear_988_2954)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.5528 9.66698C12.1315 17.2384 12.8108 36.1617 17.5743 43.0217C23.1162 51.0028 52.2193 45.9848 56.3277 32.8809C60.4847 19.6225 39.9952 0.253522 24.5528 9.66698Z",
    fill: "url(#paint2_linear_988_2954)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M20.783 29.4736C20.783 29.4736 19.2725 36.3072 15.3793 38.0243C15.3793 38.0243 14.4563 34.6747 14.4563 32.5892C14.4563 30.5037 20.783 29.4736 20.783 29.4736Z",
    fill: "url(#paint3_linear_988_2954)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.8626 11.479C22.266 16.2842 20.7956 35.7304 27.1803 42.1903C33.565 48.6501 55.2149 41.8166 56.7338 30.2678C58.0882 19.9736 43.3484 5.72844 31.8626 11.479Z",
    fill: "#0147BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.0876 17.1987C23.0876 17.1987 24.3745 28.9529 17.148 33.1102C17.148 33.1102 13.6007 33.4934 11.5386 31.3327C11.5386 31.3327 14.7494 34.3615 18.1353 31.2067C21.5212 28.052 20.7069 19.3594 18.1353 16.5276C15.5637 13.6957 11.8519 14.441 11.8519 14.441L13.337 13.0997C13.337 13.0997 18.8062 11.9817 23.0876 17.1977V17.1987Z",
    fill: "url(#paint4_linear_988_2954)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.337 13.0998C13.337 13.0998 17.3579 12.7272 20.1669 17.4095C23.1509 22.382 20.9812 30.9782 17.3569 32.2845C13.7326 33.5909 10.0703 19.6814 10.0703 19.6814L12.1757 14.1489C12.1757 14.1489 12.5945 13.3729 13.337 13.0998Z",
    fill: "url(#paint5_linear_988_2954)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.14228 24.9485C8.65913 27.6343 9.74875 29.8288 11.2065 31.2167L11.2181 31.2241L11.6252 31.5862H11.6295C12.8087 32.5453 14.2042 32.9984 15.7126 32.8057C20.6069 32.1801 21.2651 25.066 20.6892 21.0357C20.0194 16.3798 16.0501 13.5839 12.8921 13.9926C9.13485 14.4806 7.12861 19.6912 8.14334 24.9485H8.14228Z",
    fill: "#3CCBDA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.72,
    d: "M19.8907 26.7139C19.8907 26.7139 19.3707 31.0776 16.1788 32.0209C12.9859 32.9641 10.388 30.6478 9.57153 27.3723C9.57153 27.3723 10.5736 30.1968 14.7316 29.4738C18.8886 28.7507 19.8917 26.7139 19.8917 26.7139H19.8907Z",
    fill: "url(#paint6_linear_988_2954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.72,
    d: "M19.302 18.4705C19.2651 19.2836 13.4025 17.595 11.5387 17.8438C9.67482 18.0926 8.88266 20.3877 8.58521 20.3327C8.28776 20.2776 9.07991 14.9135 12.5449 14.5154C16.01 14.1184 19.3273 17.9052 19.302 18.4705Z",
    fill: "url(#paint7_linear_988_2954)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M49.0877 26.4171C51.0813 27.5223 53.9872 25.0578 53.2594 22.101C52.5316 19.1442 49.1056 16.7739 47.4084 17.7087C45.7113 18.6435 45.7735 24.5793 49.0877 26.4171Z",
    fill: "#3CCBDA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M31.1096 33.0192C34.2497 35.2001 37.6441 31.6144 37.6082 28.4321C37.5724 25.2499 34.6506 22.1226 31.7499 22.9198C28.5739 23.7921 27.884 30.7802 31.1096 33.0192Z",
    fill: "#3CCBDA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M40.6881 34.1189C40.3959 34.6471 44.19 37.226 46.0127 36.4743C48.1476 35.5935 47.8154 31.0583 47.4198 30.7503C47.0243 30.4422 41.1838 33.2243 40.6891 34.1189H40.6881Z",
    fill: "#2F95CD"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M25.1498 28.2398C26.8628 30.5825 31.7265 22.5453 36.9763 19.8447C42.9644 16.7651 51.6697 20.0279 52.2572 19.0761C52.8447 18.1244 45.4221 9.73254 35.8286 11.2252C26.2362 12.7179 23.5686 26.078 25.1498 28.2398Z",
    fill: "url(#paint8_linear_988_2954)"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M11.9141 32.0682C11.9141 32.0682 11.5692 29.7435 13.0459 28.9611C13.0459 28.9611 15.2674 28.8426 15.8211 30.999C15.8211 30.999 11.4405 45.0822 15.0205 47.3371C18.3548 49.4364 27.1413 45.1256 27.1413 45.1256L27.8512 45.7046C27.8512 45.7046 20.3969 50.3838 15.6819 48.9335C10.9669 47.4821 11.9152 32.0693 11.9152 32.0693L11.9141 32.0682Z",
    fill: "url(#paint9_linear_988_2954)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M24.9422 45.3281C24.1933 46.8684 26.8798 47.5798 28.8386 47.2601C31.0368 46.9012 34.5926 45.0009 33.7698 42.908C32.946 40.8151 26.6984 41.7181 24.9432 45.3291L24.9422 45.3281Z",
    fill: "#8666DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M25.1499 45.517C25.1826 45.8875 32.8226 43.8581 32.6295 42.4564C32.4365 41.0558 24.8989 42.6491 25.1499 45.517Z",
    fill: "#9979DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M15.258 46.4053C15.4911 47.5825 14.9774 48.6761 14.1115 48.8486C13.2455 49.0212 12.3552 48.2071 12.1221 47.0299C11.889 45.8527 12.4027 44.7591 13.2687 44.5865C14.1347 44.414 15.0249 45.2281 15.258 46.4053Z",
    fill: "#9979DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M15.1125 46.4744C15.2939 47.3901 14.8941 48.2423 14.2201 48.3757C13.5461 48.5102 12.8531 47.876 12.6717 46.9603C12.4902 46.0446 12.89 45.1924 13.564 45.059C14.238 44.9245 14.931 45.5587 15.1125 46.4744Z",
    fill: "#3CCBDA"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M23.3062 13.5635C23.2925 14.3437 28.0422 10.4776 27.4484 10.1578C26.8545 9.83814 23.3209 12.67 23.3062 13.5635Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M39.1534 6.68235C39.4508 7.30272 41.4265 6.0027 41.1333 5.46491C40.84 4.92712 38.857 6.06093 39.1534 6.68235Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M6.98193 51.3988C6.98193 51.7757 8.9618 51.3469 8.81307 51.0304C8.66435 50.7138 6.98193 50.7731 6.98193 51.3988Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M12.5397 30.8497C12.0228 30.6772 11.7866 37.9246 12.2053 38.0241C12.6241 38.1237 13.3392 31.1165 12.5397 30.8497Z",
    fill: "url(#paint10_linear_988_2954)"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_988_2954",
    x1: 46.6991,
    y1: 18.5729,
    x2: 44.014,
    y2: 6.64294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45FFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_988_2954",
    x1: 42.582,
    y1: 15.1731,
    x2: 40.2734,
    y2: 4.91603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1D1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_988_2954",
    x1: 33.3278,
    y1: 47.6479,
    x2: 38.3677,
    y2: 7.65797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DCF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_988_2954",
    x1: 17.6197,
    y1: 38.0243,
    x2: 17.6197,
    y2: 29.4736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_988_2954",
    x1: 17.3569,
    y1: 33.1366,
    x2: 17.3569,
    y2: 13.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1D1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_988_2954",
    x1: 15.82,
    y1: 32.3703,
    x2: 15.82,
    y2: 13.0924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_988_2954",
    x1: 14.7316,
    y1: 32.2326,
    x2: 14.7316,
    y2: 26.7139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_988_2954",
    x1: 19.302,
    y1: 17.4098,
    x2: 8.52825,
    y2: 17.4098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_988_2954",
    x1: 24.7237,
    y1: 19.8553,
    x2: 52.2888,
    y2: 19.8553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_988_2954",
    x1: 17.2264,
    y1: 49.3149,
    x2: 21.6672,
    y2: 30.9411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_988_2954",
    x1: 12.4458,
    y1: 38.0252,
    x2: 12.4458,
    y2: 30.8465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DCF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriaSideIcon);
export default __webpack_public_path__ + "static/media/pria-side-icon.cb8abf6384657a21be5b35cbd1c5d024.svg";
export { ForwardRef as ReactComponent };